import { useMapEvents, useMap } from 'react-leaflet';

export const AddPointOnClick = ({ createPointObject, setClickedPoints }) => {
    
    useMapEvents({
        click: (e) => {
            const newPoint = createPointObject(e.latlng);
            setClickedPoints(prev => [...prev, newPoint]);
        },
    });

    return null;
};
    
export const BoundsUpdater = ({ setBounds }) => {
    const map = useMap();
    useMapEvents({
        moveend: () => {
            setBounds(map.getBounds());
        },
        zoomend: () => {
            setBounds(map.getBounds());
        }
    });
    return null;
};